import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "../Hooks/AuthProvider";
import { getActiveSyncProgress } from "../Utils/calendarSyncHelpers";
import "./GoogleSignInCornerLoader.css";

function getCalendarUpdateLabel(syncProgress, label) {
  const processed = syncProgress?.processedEvents ?? 0;
  const total = syncProgress?.totalEvents ?? 0;
  const phase = syncProgress?.phase;

  if (phase === "linking") {
    return "Linking Google Calendar…";
  }
  if (phase === "counting" || (total === 0 && processed === 0)) {
    return `${label}: counting events…`;
  }
  if (total > 0) {
    const percent = Math.min(100, Math.round((processed / total) * 100));
    return `${label}: ${percent}% (${processed}/${total})`;
  }
  return `${label}: syncing…`;
}

const GoogleSignInCornerLoader = () => {
  const { isCompletingGoogleSignIn, userSettings } = useAuth();

  const activeSync = getActiveSyncProgress(userSettings);
  const syncProgress = activeSync?.progress;
  const isUpdatingCalendar = !!activeSync || (
    userSettings?.isSyncing && syncProgress?.status === "in_progress"
  );

  if (!isCompletingGoogleSignIn && !isUpdatingCalendar) {
    return null;
  }

  const label = isCompletingGoogleSignIn
    ? "Signing in…"
    : getCalendarUpdateLabel(syncProgress, activeSync?.label || "Calendar");

  const total = syncProgress?.totalEvents ?? 0;
  const processed = syncProgress?.processedEvents ?? 0;
  const showDeterminate = isUpdatingCalendar && total > 0;
  const progressValue = showDeterminate
    ? Math.min(100, Math.round((processed / total) * 100))
    : undefined;

  return (
    <div className="google-sign-in-corner-loader" role="status" aria-live="polite">
      <CircularProgress
        size={22}
        thickness={4}
        variant={showDeterminate ? "determinate" : "indeterminate"}
        value={progressValue}
        sx={{ color: "#fff" }}
      />
      <span className="google-sign-in-corner-loader__label">{label}</span>
    </div>
  );
};

export default GoogleSignInCornerLoader;
